import { createSelector } from "reselect";
import get from "lodash/get";
import { forms } from "utils/constants";

export const cancelPortInFormDomain = state =>
  get(state, `form.${forms.CANCEL_PORTIN_FORM}.values`, {});

/**
 * ************ Cancel PortIn Form Selectors ************
 */

export const cancelPortInFormSelector = createSelector(
  cancelPortInFormDomain,
  cancelPortInForm => cancelPortInForm
);

/**
 * ************ Make Selectors ************
 */

export const makeSelectCancelPortinForm = () => cancelPortInFormSelector;
